<template>
    <div class="bar-card-item">
        <div class="bar-card-title">{{item.name}}</div>
        <div></div>
        <div class="bar-card-value">
            {{transformValue}}
            <span v-if="item.isPercent" style="font-size: 20rem">%</span>
        </div>

        <div class="bar-card-icon" v-if="item.isPercent && item.value !== '0.0' && item.value !== '--'">
            <img :src="item.value < 0 ? 
                require('../../../assets/img/xia.png') : 
                require('../../../assets/img/shang.png')" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: Object
    },
    computed: {
        transformValue: function () {
            if (this.item.isPercent) {
                return this.item.value + ' ';
            }
            return this.item.value;
        }
    }
}
</script>

<style lang="less" scoped>
.bar-card-item {
    display: flex;
    align-items: center;
    background: rgba(13, 148, 255, 0.04);
    .h(77);
    .w(272);

    .bar-card-title {
        padding-left: 30rem;
        min-width: 50%;
        
        font-size: 18rem;
        font-weight: 400;
        color: '#666666';
    }

    .bar-card-value {       
        font-size: 24rem;
        font-weight: bold;
        color: '#333333';
    }

    .bar-card-icon {
        display: flex;
        align-items: center;
        width: 24rem;
        img {
            width: 100%;
            margin-left: 5rem;
        }
    }
}
</style>